import {sandbox, locations} from '@servicenow/ui-internal';
import log from '../log';

export default function computeProperty(name, propertyDefinition, {state, host}) {
	return sandbox(propertyDefinition.computed, {
		args: [state],
		dispatch: host.helpers,
		host,
		location: locations.PROPERTY,
		details: {compute: true, name},
		log
	});
}
